import { mapActions, mapState } from 'pinia';
import { createAlert } from '~/alert';
import { __ } from '~/locale';
import AwardsList from '~/vue_shared/components/awards_list.vue';
import { useNotes } from '~/notes/store/legacy_notes';
export default {
    name: 'NoteAwardsList',
    components: {
        AwardsList
    },
    props: {
        awards: {
            type: Array,
            required: true
        },
        toggleAwardPath: {
            type: String,
            required: true
        },
        noteId: {
            type: String,
            required: true
        },
        canAwardEmoji: {
            type: Boolean,
            required: true
        },
        defaultAwards: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    computed: {
        ...mapState(useNotes, [
            'getUserData'
        ])
    },
    methods: {
        ...mapActions(useNotes, [
            'toggleAwardRequest'
        ]),
        handleAward (awardName) {
            const data = {
                endpoint: this.toggleAwardPath,
                noteId: this.noteId,
                awardName
            };
            this.toggleAwardRequest(data).catch(()=>createAlert({
                    message: __('Something went wrong on our end.')
                }));
        }
    }
};
